import { useEffect, useState } from "react";
import { Navigate, BrowserRouter, Routes, Route } from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import { isMobileDevice } from "./utils/device";
import WebsiteGenerator from "./pages/GenerateWebsitePage";
import ProgramsManagerPage from "./pages/ProgramsManagerPage";
import DevPlaygroundPage from "./pages/DevPlaygroundPage";
import MobileLandingPage from "./pages/MobileLandingPage";
import MobileGeneratePage from "./pages/MobileGeneratePage";

function useIsMobileRoute() {
    const [isMobile, setIsMobile] = useState(() => isMobileDevice());

    useEffect(() => {
        const update = () => {
            setIsMobile(isMobileDevice());
        };

        update();

        window.addEventListener("resize", update);
        window.visualViewport?.addEventListener("resize", update);
        window.addEventListener("orientationchange", update);

        return () => {
            window.removeEventListener("resize", update);
            window.visualViewport?.removeEventListener("resize", update);
            window.removeEventListener("orientationchange", update);
        };
    }, []);

    return isMobile;
}

function AppRoutes() {
    const isMobile = useIsMobileRoute();

    return (
        <Routes>
            <Route
                path="/"
                element={isMobile ? <MobileLandingPage /> : <LandingPage />}
            />

            <Route
                path="/generate"
                element={
                    isMobile
                        ? <Navigate to={`/generate/mobile${window.location.search || ""}`} replace />
                        : <WebsiteGenerator />
                }
            />

            <Route
                path="/generate/mobile"
                element={
                    isMobile
                        ? <MobileGeneratePage />
                        : <Navigate to={`/generate${window.location.search || ""}`} replace />
                }
            />

            <Route path="/crm/programs" element={<ProgramsManagerPage />} />
            <Route path="/dev/playground" element={<DevPlaygroundPage />} />
        </Routes>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    );
}

export default App;